<template>
<div v-if="items">
    <v-row no-gutters>
      <v-col class="ml-4 font18 bold headline1 mt-4">Level {{namelevel}} Rewards</v-col>
    </v-row>
   <v-card
      v-for="(item, i) in filteritem"
      :key="i"
      class="ml-4 mr-4 mb-5 mt-4"
      style="border-radius: 20px;"
      width="93%"
      elevation="3"
    >
      <div style="display: flex">
        <div style="height: 120px; width: 122px">
          <v-img
            :src="item.pictureUrl"
            height="120"
            width="140"
            class="link"
            :style="item.quotaCode <= 0? 'opacity: 0.5;border-radius: 20px;' : 'opacity: 1;' + 'border-radius: 20px;'"
            @click="$router.push(`/reward/detail/${item.rewardId}`)"
          >
            <div v-if="item.levelNm !== 'All Level'">
              <div
                :style="
                  'width: 150px;' +
                  'height: 2px;' +
                  'transform: rotate(-30deg);' +
                  'position:absolute;' +
                  'top:0;' +
                  'left:-50px;' +
                  'background-color:' +
                  item.color
                "
              ></div>
              <div
                :style="`width: 180px;height: 2px;background-color: ${item.color};transform: rotate(-30deg);position:absolute;top:2px;left:-20px;`"
              ></div>
              <div
                :style="`height:20px;position:absolute;right:30px;top:4px;width:130px;background-color:${item.color};transform: rotate(-30deg);text-align:center;color:white;text-shadow: 1px 1px #000000; `"
              >
                <p style="font-size: 12px">{{ item.levelNm }}</p>
              </div>
            </div>
          </v-img>
        </div>
        <div style="padding: 8px; position: relative; width: 100vh">
          <div height="100" v-if="$i18n.locale === 'en' && item.nameEng !== '' && item.nameEng !== null">
            <div class="font16 bold headline1" @click="$router.push(`/reward/detail/${item.rewardId}`)">{{ item.nameEng.substring(0, 79) }}</div>
          </div>
          <div height="100" v-else>
            <div class="font16 bold headline1" @click="$router.push(`/reward/detail/${item.rewardId}`)">{{ item.name.substring(0, 79) }}</div>
          </div>
          <div height="100" v-show="item.name.length <= 49">
            <div class="font14" @click="$router.push(`/reward/detail/${item.rewardId}`)">{{ item.subName.substring(0, 41) }}</div>
          </div>
          <div v-if="item.supply === 'จัดส่ง'" height="100">
            <div class="font14"><v-icon>mdi-cube-send</v-icon> {{ item.supply }}</div>
          </div>
          <div v-if="item.supply === 'รับหน้าร้าน'" height="100">
            <div class="font14"><v-icon>mdi-store</v-icon> {{ item.supply }}</div>
          </div>
          <div style="position: absolute;bottom: 10px;width: 91%;">
            <div
              v-if="item.quotaCode > 0"
              class="bold"
              :style="'color:' + $textcolor + ';background-color:' + $bgColor2 +
              ';text-align: center;display:flex;border-radius: 10px;padding:3px;font-size: 15px;justify-content: center;'"
              @click="checkLevelAndCoin(item)"
              ><div class=""><img
                  v-if="profile.pictureUrl"
                  style="
                    border-color: white;
                    height: 22px;
                    margin-right:5px;
                    padding-bottom: 4px;
                  "
                  alt="Avatar"
                  :src="require('@/assets/coin.png')"
                /></div>
              <div>
                {{ formatNumber(item.point) }}
              </div>
              <div
                v-if="item.resale || item.resale > 0"
                style="margin-left:5px;font-size: 13px;
                display: flex;
                align-items: center;
                color: rgb(236 229 229);
                text-decoration: line-through 1px !important;"><div style="text-decoration: line-through !important;">{{ formatNumber(item.resale) }}</div>
              </div>
            </div>
            <v-btn
              v-if="item.quotaCode <= 0"
              small
              disabled
              class="pa-0 mr-3 mb-3 font17 bold"
              style="
                width: 100px;
                position: absolute;
                bottom: 0;
                right: 0;
                text-align: center;
              "
              >สินค้าหมด</v-btn
            >
          </div>
          <!-- <div>
            <v-card
              v-if="item.quotaCode > 0"
              class="pa-0 mr-3 mb-3 font17 bold"
              style="
                width: 100px;
                position: absolute;
                bottom: 0;
                right: 0;
                color: #fff;
                background-color: #d82148;
                text-align: center;
              "
              @click="checkLevelAndCoin(item)"
              >
              <img
                  v-if="profile.pictureUrl"
                  style="
                    border-color: white;
                    height: 22px;
                    margin-right:5px;
                    padding-bottom: 4px;
                  "
                  alt="Avatar"
                  :src="require('@/assets/coin.png')"
                />{{ formatNumber(item.point) }}
              </v-card>
            <v-btn
              v-if="item.quotaCode <= 0"
              small
              disabled
              class="pa-0 mr-3 mb-3 font17 bold"
              style="
                width: 100px;
                position: absolute;
                bottom: 0;
                right: 0;
                text-align: center;
              "
              >สินค้าหมด</v-btn
            >
          </div> -->
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Swal from 'sweetalert2'
import moment from 'moment'
export default {
  name: 'AllRewards',
  data () {
    return {
      id: this.$route.params.id,
      items: null,
      filteritem: null,
      namelevel: null,
      member: null,
      profile: null
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted () {
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    await this.getReward()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),

    async checkLevelAndCoin (items) {
      if (items.levelNm === 'All Level') {
        if (this.member.currentPoint >= items.point) {
          await this.redeemReward(items)
          this.member = this.GET_MEMBERINFO()
        } else if (this.member.currentPoint < items.point) {
          const Toast = Swal.mixin({
            toast: true,
            position: 'center',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonColor: '#6ECB63',
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก'
          })
          Toast.fire({
            icon: 'error',
            width: 3000,
            title: 'Coin ของคุณไม่พอ  :( ',
            html: 'คุณต้องการไป หน้ากิจกรรม เพื่อเข้าร่วมเเละรับ Coin หรือไม่ ?',
            backdrop: `rgba(0,0,001,0.4)`
          })
        }
      } else if (items.levelNm !== 'All Level') {
        if (this.member.levelPoint >= items.levelPoint) {
          if (this.member.currentPoint >= items.point) {
            await this.redeemReward(items)
            this.member = this.GET_MEMBERINFO()
          } else if (this.member.currentPoint < items.point) {
            const Toast = Swal.mixin({
              toast: true,
              position: 'center',
              showConfirmButton: true,
              showCancelButton: true,
              confirmButtonColor: '#6ECB63',
              confirmButtonText: 'ยืนยัน',
              cancelButtonText: 'ยกเลิก'
            })
            Toast.fire({
              icon: 'error',
              width: 3000,
              title: 'Coin ของคุณไม่พอ  :( ',
              html: 'คุณต้องการไป หน้ากิจกรรม เพื่อเข้าร่วมเเละรับ Coin หรือไม่ ?',
              backdrop: `rgba(0,0,001,0.4)`
            }).then((confirm) => {
              if (confirm.isConfirmed) {
                this.$router.push('/activity')
              }
            })
          }
        } else if (this.member.levelPoint < items.levelPoint) {
          const Toast = Swal.mixin({
            toast: true,
            position: 'center',
            showConfirmButton: true,
            confirmButtonColor: '#6ECB63',
            confirmButtonText: 'ตกลง'
          })
          Toast.fire({
            icon: 'error',
            width: 3000,
            title: 'ระดับบัตรสมาชิกไม่พอ :(',
            html: 'สามารถเเลกได้เฉพาะ member ที่มีเลเวล ' + items.levelNm + ' ขึ้นไปเท่านั้น',
            backdrop: `rgba(0,0,001,0.4)`
          }).then((confirm) => {
            if (confirm.isConfirmed) {
              this.$router.push('/tierBenefit')
            }
          })
        }
      }
    },
    async getReward () {
      const result = await this.callBeTaskAPI('get', '/reward/line/get?RECORD_STATUS=N')
      if (result) {
        this.items = result.filter(item => item.expireTypeReward === 'FixDate' && moment(this.DateNow).format('YYYY-MM-DD') >= moment(item.startDate).format('YYYY-MM-DD') && moment(this.DateNow).format('YYYY-MM-DD') < moment(item.endDate).format('YYYY-MM-DD'))
      }
    },
    getSerach (level) {
      this.namelevel = level
      this.filteritem = this.items.filter(item => item.levelName === level)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SearchReward.vue